import { SimpleGrid, Text } from "@mantine/core";
import React from "react";
import TextInput from "../../../../components/Input/TextInput";

const AmountFinancedDropdown = ({ form }) => {
  return (
    <SimpleGrid cols={2} spacing={5}>
      <Text size={"sm"} mt={"md"}>
        Contract Amount Financed
      </Text>
      <TextInput placeholder="Amount financed" form={form} validateName="amountFinanced" size="xs" disabled />

      <Text size={"sm"} mt={"md"}>
        Contract Finance Charges
      </Text>
      <TextInput placeholder="Finance Charges" form={form} validateName="financeCharges" size="xs" disabled />
    </SimpleGrid>
  );
};

export default AmountFinancedDropdown;
